"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPlacements;
exports.getOverflowOptions = getOverflowOptions;
exports.isCornerPlacement = isCornerPlacement;
exports.isValidPlacement = isValidPlacement;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 启用自动调整溢出的默认选项
var autoAdjustOverflowEnabled = {
  adjustX: true,
  adjustY: true
};
// 禁用自动调整溢出的默认选项
var autoAdjustOverflowDisabled = {
  adjustX: false,
  adjustY: false
};
// 目标偏移量默认值
var targetOffset = [0, 0];
/**
 * 获取溢出选项
 * @param autoAdjustOverflow 自动调整溢出的配置
 * @returns 溢出选项
 */
function getOverflowOptions(autoAdjustOverflow) {
  if (typeof autoAdjustOverflow === 'boolean') {
    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }
  return _objectSpread(_objectSpread({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
}
/**
 * 获取放置位置配置
 * @param config 放置配置
 * @returns 放置位置映射
 */
function getPlacements() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$arrowWidth = config.arrowWidth,
    arrowWidth = _config$arrowWidth === void 0 ? 6 : _config$arrowWidth,
    _config$autoAdjustOve = config.autoAdjustOverflow,
    autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
  var arrowToContentGutter = arrowWidth / 2 + 4;
  var placementMap = {
    left: {
      points: ['cr', 'cl'],
      offset: [-arrowToContentGutter, 0]
    },
    right: {
      points: ['cl', 'cr'],
      offset: [arrowToContentGutter, 0]
    },
    top: {
      points: ['bc', 'tc'],
      offset: [0, -arrowToContentGutter]
    },
    bottom: {
      points: ['tc', 'bc'],
      offset: [0, arrowToContentGutter]
    },
    topLeft: {
      /*
       * points: ['bl', 'tc'],
       * offset: [-(horizontalArrowShift + arrowWidth), -arrowToContentGutter],
       */
      points: ['bl', 'tl'],
      offset: [0, -arrowToContentGutter]
    },
    leftTop: {
      /*
       * points: ['tr', 'cl'],
       * offset: [-arrowToContentGutter, -(verticalArrowShift + arrowWidth)],
       */
      points: ['tr', 'tl'],
      offset: [-arrowToContentGutter, 0]
    },
    topRight: {
      /*
       * points: ['br', 'tc'],
       * offset: [horizontalArrowShift + arrowWidth, -arrowToContentGutter],
       */
      points: ['br', 'tr'],
      offset: [0, -arrowToContentGutter]
    },
    rightTop: {
      /*
       * points: ['tl', 'cr'],
       * offset: [arrowToContentGutter, -(verticalArrowShift + arrowWidth)],
       */
      points: ['tl', 'tr'],
      offset: [arrowToContentGutter, 0]
    },
    bottomRight: {
      /*
       * points: ['tr', 'bc'],
       * offset: [horizontalArrowShift + arrowWidth, arrowToContentGutter],
       */
      points: ['tr', 'br'],
      offset: [0, arrowToContentGutter]
    },
    rightBottom: {
      /*
       * points: ['bl', 'cr'],
       * offset: [arrowToContentGutter, verticalArrowShift + arrowWidth],
       */
      points: ['bl', 'br'],
      offset: [arrowToContentGutter, 0]
    },
    bottomLeft: {
      /*
       * points: ['tl', 'bc'],
       * offset: [-(horizontalArrowShift + arrowWidth), arrowToContentGutter],
       */
      points: ['tl', 'bl'],
      offset: [0, arrowToContentGutter]
    },
    leftBottom: {
      /*
       * points: ['br', 'cl'],
       * offset: [-arrowToContentGutter, verticalArrowShift + arrowWidth],
       */
      points: ['br', 'bl'],
      offset: [-arrowToContentGutter, 0]
    }
  };
  // 为每个放置位置添加溢出选项和目标偏移量
  Object.keys(placementMap).forEach(function (key) {
    placementMap[key] = config.arrowPointAtCenter ? _objectSpread(_objectSpread({}, placementMap[key]), {}, {
      overflow: getOverflowOptions(autoAdjustOverflow),
      targetOffset: targetOffset
    }) : _objectSpread(_objectSpread({}, placementMap[key]), {}, {
      overflow: getOverflowOptions(autoAdjustOverflow)
    });
  });
  return placementMap;
}
// 定义8个边角放置位置
var CornerPlacement = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom'];
/**
 * 判断放置位置是否为8个边角之一
 * @param {string} placement 放置位置
 * @returns {boolean} 是否为边角放置位置
 */
function isCornerPlacement(placement) {
  return CornerPlacement.some(function (corner) {
    return corner === placement;
  });
}
// 定义有效的放置位置
var validPlacements = ['top', 'left', 'right', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom'];
/**
 * 判断放置位置是否有效
 * @param {string} placement 放置位置
 * @returns {boolean} 是否为有效的放置位置
 */
function isValidPlacement(placement) {
  return validPlacements.includes(placement);
}